import type { ReactNode } from 'react'
import { RouterProvider } from '@heroui/react'
import { useHref, useNavigate } from 'react-router-dom'

/**
 * Lets React Aria components (Link, Menu items, …) navigate through React Router
 * instead of doing a full page load. Must render inside a Router.
 */
export function HeroUIRouterProvider({ children }: { children: ReactNode }) {
  const navigate = useNavigate()

  return (
    <RouterProvider navigate={navigate} useHref={useHref}>
      {children}
    </RouterProvider>
  )
}
